(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["duo-accessory"]) return;
  try {
    

if (!customElements.get('duo-product')) {

  customElements.define('duo-product', class extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.form = this.querySelector('.dp-form');

      this.quantity = this.querySelector('[name="quantity"]');

      this.buttons = [...this.querySelectorAll('[data-add-button]')];

      this.dialog = this.querySelector('dialog');

      this.syncQuantity();

      this.addEventListener('click', event => {

        const thumb = event.target.closest('[data-thumbnail]');

        if (thumb) {

          event.preventDefault();

          this.querySelectorAll('[data-media-id]').forEach(panel => {

            panel.hidden = panel.dataset.mediaId !== thumb.dataset.thumbnail;

            if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());

          });

          this.querySelectorAll('[data-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));

        }

        const quantityButton = event.target.closest('[data-quantity-change]');

        if (quantityButton) {

          const minimum = Number(this.quantity.min) || 1;

          const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;

          const step = Number(this.quantity.step) || 1;

          const value = Number(this.quantity.value) || minimum;

          this.quantity.value = Math.min(maximum, Math.max(minimum, value + Number(quantityButton.dataset.quantityChange) * step));

          this.syncQuantity();

        }

        const zoom = event.target.closest('[data-zoom]');

        if (zoom && typeof this.dialog.showModal === 'function') {

          event.preventDefault();

          const image = this.dialog.querySelector('img');

          image.src = zoom.href;

          image.alt = zoom.querySelector('img').alt;

          this.dialog.showModal();

        }

        if (event.target.closest('.dp-lightbox-close')) this.dialog.close();

      });

      this.addEventListener('keydown', event => {

        if (event.key === ' ' && event.target.matches('[data-thumbnail]')) {

          event.preventDefault();

          event.target.click();

        }

      });

      this.dialog.addEventListener('click', event => {

        if (event.target !== this.dialog) return;

        const bounds = this.dialog.getBoundingClientRect();

        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();

      });

      this.quantity.addEventListener('change', () => this.syncQuantity());

      this.querySelector('[data-variant]')?.addEventListener('change', event => {

        const url = new URL(window.location.href);

        url.searchParams.set('variant', event.target.value);

        window.location.assign(url.toString());

      });

      this.form.addEventListener('submit', event => this.addToBag(event));

    }

    syncQuantity() {

      const value = Number(this.quantity.value);

      const minimum = Number(this.quantity.min) || 1;

      const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;

      this.querySelector('[data-quantity-change="-1"]').disabled = value <= minimum;

      this.querySelector('[data-quantity-change="1"]').disabled = value >= maximum;

    }

    async addToBag(event) {

      event.preventDefault();

      if (this.busy || !this.form.reportValidity()) return;

      this.busy = true;

      const error = this.querySelector('[data-form-error]');

      const success = this.querySelector('[data-form-success]');

      error.hidden = true;

      success.hidden = true;

      this.buttons.forEach(button => {

        button.disabled = true;

        button.setAttribute('aria-busy', 'true');

        button.querySelector('[data-button-label]').textContent = this.dataset.adding;

      });

      try {

        const response = await fetch(this.dataset.cartAdd, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'application/json' } });

        const result = await response.json();

        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);

        this.querySelector('[data-form-status]').textContent = this.dataset.added;

        success.hidden = false;

        try {

          const cartResponse = await fetch(this.dataset.cart, { headers: { Accept: 'application/json' } });

          if (cartResponse.ok) {

            const cart = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('bfcm:cart-added', { detail: { cart } }));

            document.querySelectorAll('[data-duo-cart-count]').forEach(count => count.textContent = cart.item_count);

            document.querySelectorAll('[data-duo-cart-link]').forEach(link => link.setAttribute('aria-label', `${link.dataset.bagLabel}, ${cart.item_count}`));

          }

        } catch {}

        success.scrollIntoView({ behavior: 'auto', block: 'nearest' });

      } catch (failure) {

        error.textContent = failure.message || this.dataset.error;

        error.hidden = false;

        error.scrollIntoView({ behavior: 'auto', block: 'nearest' });

      } finally {

        this.busy = false;

        this.buttons.forEach(button => {

          button.disabled = false;

          button.removeAttribute('aria-busy');

          button.querySelector('[data-button-label]').textContent = this.dataset.add;

        });

      }

    }

  });

}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duo-header"]) return;
  try {
    
document.addEventListener('keydown',function(e){if(e.key==='Escape')document.querySelectorAll('.duo-nav-menu[open]').forEach(function(menu){menu.open=false;menu.querySelector('summary').focus();});});document.addEventListener('click',function(e){document.querySelectorAll('.duo-nav-menu[open]').forEach(function(menu){if(!menu.contains(e.target))menu.open=false;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["duo-product"]) return;
  try {
    

if (!customElements.get('duo-product')) {

  customElements.define('duo-product', class extends HTMLElement {

    connectedCallback() {

      if (this.initialized) return;

      this.initialized = true;

      this.form = this.querySelector('.dp-form');

      this.loadOptions();
      this.quantity = this.querySelector('[name="quantity"]');

      this.buttons = [...this.querySelectorAll('[data-add-button]')];

      this.dialog = this.querySelector('dialog');

      if (this.quantity) this.syncQuantity();

      this.addEventListener('click', event => {

        const thumb = event.target.closest('[data-thumbnail]');

        if (thumb) {

          event.preventDefault();

          this.querySelectorAll('[data-media-id]').forEach(panel => {

            panel.hidden = panel.dataset.mediaId !== thumb.dataset.thumbnail;

            if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());

          });

          this.querySelectorAll('[data-thumbnail]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));

        }

        const quantityButton = event.target.closest('[data-quantity-change]');

        if (quantityButton) {

          const minimum = Number(this.quantity.min) || 1;

          const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;

          const step = Number(this.quantity.step) || 1;

          const value = Number(this.quantity.value) || minimum;

          this.quantity.value = Math.min(maximum, Math.max(minimum, value + Number(quantityButton.dataset.quantityChange) * step));

          if (this.quantity) this.syncQuantity();

        }

        const zoom = event.target.closest('[data-zoom]');

        if (zoom && typeof this.dialog.showModal === 'function') {

          event.preventDefault();

          const image = this.dialog.querySelector('img');

          image.src = zoom.href;

          image.alt = zoom.querySelector('img').alt;

          this.dialog.showModal();

        }

        if (event.target.closest('.dp-lightbox-close')) this.dialog.close();

      });

      this.addEventListener('keydown', event => {

        if (event.key === ' ' && event.target.matches('[data-thumbnail]')) {

          event.preventDefault();

          event.target.click();

        }

      });

      this.dialog.addEventListener('click', event => {

        if (event.target !== this.dialog) return;

        const bounds = this.dialog.getBoundingClientRect();

        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();

      });

      this.quantity?.addEventListener('change', () => this.syncQuantity());

      this.querySelector('[data-variant]')?.addEventListener('change', event => {

        const url = new URL(window.location.href);

        url.searchParams.set('variant', event.target.value);

        window.location.assign(url.toString());

      });

      this.form?.addEventListener('submit', event => this.addToBag(event));

    }

    async loadOptions() {
      const select = this.querySelector('[data-variant]');
      const node = this.querySelector('[data-bf-variant-page]');
      if (!select || !node) return;
      try {
        const first = JSON.parse(node.textContent);
        if (!first.next) return;
        const variants = [...first.variants];
        const visited = new Set();
        let next = first.next;
        while (next) {
          const url = new URL(next, location.origin);
          url.pathname = this.dataset.productUrl;
          if (visited.has(url.href) || visited.size >= 20) throw new Error(this.dataset.optionsError);
          visited.add(url.href);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error(this.dataset.optionsError);
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(page.querySelector('[data-bf-variant-page]').textContent);
          variants.push(...data.variants);
          next = data.next;
        }
        const selectedId = select.value;
        const money = new Intl.NumberFormat(this.dataset.locale, {style:'currency', currency:this.dataset.currency});
        const options = document.createDocumentFragment();
        for (const variant of new Map(variants.map(value => [String(value.id), value])).values()) {
          const option = new Option(`${variant.title} — ${money.format(variant.price / 100)}${variant.available ? '' : ' · ' + this.dataset.soldOut}`, String(variant.id));
          option.disabled = !variant.available;
          option.selected = String(variant.id) === selectedId;
          options.append(option);
        }
        select.replaceChildren(options);
      } catch {
        const error = this.querySelector('[data-form-error]');
        error.textContent = this.dataset.optionsError;
        error.hidden = false;
      }
    }

    syncQuantity() {

      const value = Number(this.quantity.value);

      const minimum = Number(this.quantity.min) || 1;

      const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;

      this.querySelector('[data-quantity-change="-1"]').disabled = value <= minimum;

      this.querySelector('[data-quantity-change="1"]').disabled = value >= maximum;

    }

    async addToBag(event) {

      event.preventDefault();

      if (this.busy || !this.form.reportValidity()) return;

      this.busy = true;

      const error = this.querySelector('[data-form-error]');

      const success = this.querySelector('[data-form-success]');

      error.hidden = true;

      success.hidden = true;

      this.buttons.forEach(button => {

        button.disabled = true;

        button.setAttribute('aria-busy', 'true');

        button.querySelector('[data-button-label]').textContent = this.dataset.adding;

      });

      try {

        const response = await fetch(this.dataset.cartAdd, { method: 'POST', body: new FormData(this.form), headers: { Accept: 'application/json' } });

        const result = await response.json();

        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);

        this.querySelector('[data-form-status]').textContent = this.dataset.added;

        success.hidden = false;

        try {

          const cartResponse = await fetch(this.dataset.cart, { headers: { Accept: 'application/json' } });

          if (cartResponse.ok) {

            const cart = await cartResponse.json();
            document.dispatchEvent(new CustomEvent('bfcm:cart-added', { detail: { cart } }));

            document.querySelectorAll('[data-duo-cart-count]').forEach(count => count.textContent = cart.item_count);

            document.querySelectorAll('[data-duo-cart-link]').forEach(link => link.setAttribute('aria-label', `${link.dataset.bagLabel}, ${cart.item_count}`));

          }

        } catch {}

        success.scrollIntoView({ behavior: 'auto', block: 'nearest' });

      } catch (failure) {

        error.textContent = failure.message || this.dataset.error;

        error.hidden = false;

        error.scrollIntoView({ behavior: 'auto', block: 'nearest' });

      } finally {

        this.busy = false;

        this.buttons.forEach(button => {

          button.disabled = this.dataset.available === 'false';

          button.removeAttribute('aria-busy');

          button.querySelector('[data-button-label]').textContent = this.dataset.add;

        });

      }

    }

  });

}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
